/** * * Asynchronously loads the component for
Disclosure
* */ import { lazyLoad } from "utils/loadable";
export const Disclosure = lazyLoad(
  () => import("./index"),
  (module) => module.Disclosure
);
